export default "__VITE_ASSET__BFo5D7vN__"